export default __webpack_public_path__ + "static/media/moki@2x.87ac83fd.png";